// Formatting helpers shared by the SMS Outreach dashboard components.

export const fmtNumber = (n) => Number(n || 0).toLocaleString('en-US');

export const fmtPct = (n, digits = 1) =>
  n === null || n === undefined || Number.isNaN(Number(n)) ? '—' : `${Number(n).toFixed(digits)}%`;

export const fmtMoney = (n) =>
  Number(n || 0).toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });

export const fmtDateTime = (value) => {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZone: 'America/Los_Angeles',
  });
};

export const fmtDay = (isoDay) => {
  if (!isoDay) return '—';
  const [y, m, d] = String(isoDay).slice(0, 10).split('-').map(Number);
  if (!y || !m || !d) return String(isoDay);
  return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' });
};

export const fmtDuration = (ms) => {
  if (ms === null || ms === undefined) return '—';
  const s = Math.round(Number(ms) / 1000);
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ${s % 60}s`;
  return `${Math.floor(m / 60)}h ${m % 60}m`;
};

export const relativeTime = (value) => {
  if (!value) return '—';
  const t = new Date(value).getTime();
  if (!Number.isFinite(t)) return '—';
  const diff = t - Date.now();
  const abs = Math.abs(diff);
  const unit = abs < 60e3 ? ['s', 1e3] : abs < 3600e3 ? ['m', 60e3] : abs < 86400e3 ? ['h', 3600e3] : ['d', 86400e3];
  const n = Math.round(abs / unit[1]);
  return diff < 0 ? `${n}${unit[0]} ago` : `in ${n}${unit[0]}`;
};

export const pctDelta = (current, previous) => {
  if (previous === null || previous === undefined || previous === 0) return null;
  if (current === null || current === undefined) return null;
  return ((current - previous) / previous) * 100;
};

// Airflow / pipeline state → tone used by badges and the status card.
export const STATE_TONE = {
  success: 'emerald',
  completed: 'emerald',
  running: 'indigo',
  queued: 'amber',
  up_for_retry: 'amber',
  up_for_reschedule: 'amber',
  scheduled: 'zinc',
  failed: 'rose',
  upstream_failed: 'rose',
  skipped: 'zinc',
  none: 'zinc',
};

export const TONE_CLASSES = {
  emerald: 'bg-emerald-50 text-emerald-700 ring-emerald-600/20',
  indigo: 'bg-indigo-50 text-indigo-700 ring-indigo-600/20',
  amber: 'bg-amber-50 text-amber-700 ring-amber-600/20',
  rose: 'bg-rose-50 text-rose-700 ring-rose-600/20',
  zinc: 'bg-zinc-100 text-zinc-600 ring-zinc-500/20',
  sky: 'bg-sky-50 text-sky-700 ring-sky-600/20',
};

export const FAILURE_CATEGORY_LABELS = {
  segment_limit: 'Message too long',
  allowlist_blocked: 'Blocked by allowlist',
  invalid_phone: 'Invalid phone',
  throttled: 'Throttled (429)',
  network: 'Network / timeout',
  provider_4xx: 'Provider rejected (4xx)',
  provider_5xx: 'Provider error (5xx)',
  other: 'Other',
};

export const toIsoDay = (date) => {
  const d = new Date(date);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};
